<template>
  <v-container fluid class="full-height">
    <v-row class="fill-height">
      <v-col
        cols="12"
      >
        <v-card class="mb-6" outlined>
          <v-card-title>
            ユーザ登録が完了しました
          </v-card-title>
          
          <template v-if="user.id && user.role === 'driver_user'">
            <div v-if="user.use_allocate">
              <v-card-text >
                <div class="subtitle-2">
                  ドライバーの方はドライバー専用アプリをダウンロードしてアプリからログイン下さい
                </div>
              </v-card-text>

              <v-card-text class="d-flex align-center">
                <v-btn
                  href="https://apps.apple.com/us/app/dxe%E3%83%89%E3%83%A9%E3%82%A4%E3%83%90%E3%83%BC-%E3%83%95%E3%82%A9%E3%83%BC-%E3%82%B9%E3%83%86%E3%83%BC%E3%82%B7%E3%83%A7%E3%83%B3/id1671486386"
                  text
                  color="link"
                  min-height="20"
                  style="display:inline-block;overflow:hidden;background:url(https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83) no-repeat;width:165px;height:40px;margin: 13px;"
                >
                </v-btn>

                <v-btn
                  href="https://play.google.com/store/apps/details?id=com.dxe.driver.forstation"
                  text
                  color="link"
                  min-height="20"
                  style="display:inline-block;overflow:hidden;background:url(https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg) no-repeat;width:165px;height:40px;margin: 13px;"
                >
                </v-btn>
              </v-card-text>
            </div>
            <div v-else>
              <v-card-text>
                <div class="subtitle-2 mb-3">
                  ドライバー向けアプリはPWA（プログレッシブウェブアプリ）に対応しています。
                </div>
                <div class="body-2 mb-3">
                  PWAは、モバイルアプリと同じような閲覧体験を提供するウェブ向けのアプリで
                  ホーム画面にインストールしてモバイルアプリのように利用できるメリットがあります。
                </div>
                
                <div class="subtitle-2 mb-2">
                  ホーム画面に追加して便利に利用する方法
                </div>
                
                <div class="mb-3">
                  <div class="font-weight-bold mb-2">
                    <v-icon class="mr-2">mdi-apple</v-icon>
                    iOS(safari)
                  </div>
                  <div class="body-2">
                    1. ブラウザで <v-btn 
                        :href="url" 
                        target="_blank"
                        rel="noopener noreferrer"
                        color="info"
                        text 
                        x-small
                        class="pa-0"
                        style="text-decoration: underline; text-transform: none;"
                      >
                        {{ url }}
                      </v-btn> を開く<br>
                    2. 画面下の共有アイコンから「ホーム画面に追加」をタップ<br>
                    3. 画面の手順に沿ってPWAをホームに追加
                  </div>
                </div>
                
                <div class="mb-3">
                  <div class="font-weight-bold mb-2">
                    <v-icon class="mr-2">mdi-android</v-icon>
                    Android(chrome)
                  </div>
                  <div class="body-2">
                    1. ブラウザで <v-btn 
                        :href="url" 
                        target="_blank"
                        rel="noopener noreferrer"
                        color="info"
                        text 
                        x-small
                        class="pa-0"
                        style="text-decoration: underline; text-transform: none;"
                      >
                        {{ url }}
                      </v-btn> を開く<br>
                    2. 画面右上のメニューから「ホーム画面に追加」をタップ<br>
                    3. 画面の手順に沿ってPWAをインストール
                  </div>
                </div>
              </v-card-text>
            </div>
          </template>

          <template v-else>
            <v-card-text>
              <div class="subtitle-2">
                「スタート」ボタンを押してログインして使用下さい。
              </div>
            </v-card-text>

            <v-card-actions>
              <v-row dense>
                <v-col
                  cols="12"
                  class="text-center"
                >
                  <v-btn
                    :block="$vuetify.breakpoint.mdAndDown"
                    color="primary"
                    outlined
                    @click="moveBackButtonClickEvent"
                  >
                    スタート
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </template>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'MembershipProfileForm',
    components: {
    },
    mixins: [],
    props: {
      user: {
        type: Object,
        default: () => {
          return {}
        },
      },
    },  
    data() {
      return {
        url: process.env.VUE_APP_SCHEDULE_APP_URL,
      };
    },
    methods: {
    moveBackButtonClickEvent () {
      this.$router.replace({name: 'DriverSessions'}, () => {})
      // this.$router.push({name: 'DriverSessions'})
    },
    }

  }
</script>

<style scoped lang="scss">
</style>
